import React, { useState } from 'react'
import Box from '@mui/material/Box'
import ListItemIcon from '@mui/material/ListItemIcon'
import IconButton from '@mui/material/IconButton'
import Typography from '@mui/material/Typography'
import PermIdentityOutlinedIcon from '@mui/icons-material/PermIdentityOutlined'
import LogoutOutlinedIcon from '@mui/icons-material/LogoutOutlined'
import { StyledAvatar, StyledLink, StyledMenuItem } from './styles'
import { Menu, Theme, useMediaQuery } from '@mui/material'
import useAuthStore from 'store/userStore'
import { useDashboard } from 'store/DashboardContext'
import { useIonRouter } from '@ionic/react' // Change here
import { useQueryClient } from '@tanstack/react-query'
import { useAuthenticator } from '@aws-amplify/ui-react'

interface AccountMenuProps {
  avatar: string
}

export const AccountMenu: React.FC<AccountMenuProps> = ({ avatar }) => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null)
  const open = Boolean(anchorEl)
  const {
    state: { isSideNavOpen },
    actions: { toggleSideNav }
  } = useDashboard()
  const mobile = useMediaQuery((theme: Theme) => theme.breakpoints.down('md'))
  const router = useIonRouter() // Change here
  const { logout } = useAuthStore()
  const queryClient = useQueryClient()
  const { signOut } = useAuthenticator()

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    if (!mobile) {
      setAnchorEl(event.currentTarget)
    } else {
      !isSideNavOpen && mobile && toggleSideNav()
      router.push(
        '/dashboard/account-settings',
        'forward', // optional, use "back" to simulate a back navigation
        'replace' // optional, use "replace" to replace the current entry in the history stack
      ) // Change here
    }
  }

  const handleClose = () => {
    setAnchorEl(null)
  }

  const handleLogout = async () => {
    // logout()
    try {
      // Clear the Amplify session
      await signOut()

      // Clear local state and caches
      logout() // Clear user from your auth store
      queryClient.clear() // Clear React Query cache
      localStorage.clear() // Clear local storage to avoid stale data

      // Redirect to the login page to ensure a clean state
      window.location.href = '/login'
    } catch (error) {
      console.error('Error during logout:', error)
    }
  }

  return (
    <Box>
      <Box>
        <IconButton
          onClick={handleClick}
          size="small"
          sx={{ ml: { sm: 0, md: 2 } }}
          aria-controls={open ? 'account-menu' : undefined}
          aria-haspopup="true"
          aria-expanded={open ? 'true' : undefined}
        >
          <StyledAvatar>
            <Typography variant="caption1_bold">{avatar}</Typography>
          </StyledAvatar>
        </IconButton>
      </Box>
      {!mobile && (
        <Menu
          anchorEl={anchorEl}
          id="account-menu"
          open={open}
          onClose={handleClose}
          onClick={handleClose}
          sx={{
            overflow: 'visible',
            mt: 1
          }}
          transformOrigin={{ horizontal: 'right', vertical: 'top' }}
          anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
        >
          <StyledMenuItem sx={{ padding: 0 }} onClick={handleClose}>
            <StyledLink to={'/dashboard/account-settings'}>
              <ListItemIcon>
                <PermIdentityOutlinedIcon fontSize="small" />
              </ListItemIcon>
              <Typography variant="caption2_regular">Profile</Typography>
            </StyledLink>
          </StyledMenuItem>
          <StyledMenuItem onClick={handleLogout}>
            <ListItemIcon>
              <LogoutOutlinedIcon fontSize="small" />
            </ListItemIcon>
            <Typography variant="caption2_regular">Logout</Typography>
          </StyledMenuItem>
        </Menu>
      )}
    </Box>
  )
}
